import { CustomFormFieldConditionType } from '../../enums/forms/custom-form-field-condition-type';

export class CustomFormFieldCondition {
  public field: string;
  public type: CustomFormFieldConditionType;
  public value: string;
}
